import React, { useState } from "react";
import styles from "./BusinessesforSale.module.css";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import BusinessesforSale1 from "./BusinessesforSale1";
import useStore from "../../../Store";

const ContactCompany = () => {
  const direction = useStore((state) => state.direction);
  const [interestedIn, setInterestedIn] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [industriesInterested, setIndustriesInterested] = useState("");
  const [locationsInterested, setLocationsInterested] = useState("");
  const [dealSizeRange, setDealSizeRange] = useState({ min: "", max: "" });
  const [currentLocation, setCurrentLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [designation, setDesignation] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [businessFactors, setBusinessFactors] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [corporateProfile, setCorporateProfile] = useState(null);
  const [proofOfBusiness, setProofOfBusiness] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showServices, setShowServices] = useState(false);

  const toggleServices = () => {
    setShowServices(!showServices);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "video/mp4") {
      setVideoFile(file);
      setErrorMessage("");
    } else {
      setErrorMessage("Please upload a valid MP4 video file.");
    }
  };

  const handleUpload = () => {
    if (videoFile) {
      setVideoFile(null);
    }
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const handleTermsChange = (event) => {
    setTermsAccepted(event.target.checked);
  };

  // Handler for company logo upload
  const handleCompanyLogoChange = (event) => {
    const file = event.target.files[0];
    setCompanyLogo(file); 
  };

  // Handler for corporate profile upload
  const handleCorporateProfileChange = (event) => {
    const file = event.target.files[0];
    setCorporateProfile(file); 
  };

  // Handler for proof of business upload
  const handleProofOfBusinessChange = (event) => {
    const file = event.target.files[0];
    setProofOfBusiness(file);
  };

  // Handlers for InvestorForm
  const handleInterestedInChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setInterestedIn([...interestedIn, value]);
    } else {
      setInterestedIn(interestedIn.filter((item) => item !== value));
    }
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleDealSizeChange = (e) => {
    const { id, value } = e.target;
    setDealSizeRange((prev) => ({
      ...prev,
      [id === "dealSizeMin" ? "min" : "max"]: value,
    }));
  };

  const handleProfilePictureChange = (e) => {
    setProfilePicture(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      interestedIn,
      selectedOption,
      industriesInterested,
      locationsInterested,
      dealSizeRange,
      currentLocation,
      companyName,
      designation,
      companyWebsite,
      businessFactors,
      aboutCompany,
      profilePicture,
    };
   
  };

  return (
    <div style={{ direction }}>
      <Nav />
      <div className={styles.about_container}>
        <BusinessesforSale1 />
      </div>
      <div className={styles["withAdvisor-register-container"]}>
        <div className={styles["withAdvisor-form-container"]}>
          <h2>Register Investor Profile</h2>

          <div className={styles["User-personaldetails-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Confidential Information</h3>
              <p>
                Please enter your own details here. Information entered here is
                not publicly displayed.
              </p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="fullName">Your Full Name</label>
                <div className={styles["withAdvisor-input-field"]}>
                  <input type="text" id="fullName" placeholder="full name" />
                  <span className={styles["withAdvisor-icon"]}>?</span>
                </div>
                <p className={styles["withAdvisor-helper-text"]}>
                  Please enter your full name
                </p>
              </div>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="email">Enter official email</label>
                <div className={styles["withAdvisor-input-field"]}>
                  <input
                    type="email"
                    id="email"
                    placeholder="example@mail.com"
                  />
                  <span className={styles["withAdvisor-icon"]}>?</span>
                </div>
              </div>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="phone">Your Mobile Number</label>
                <div
                  className={`${styles["withAdvisor-input-field"]} ${styles["withAdvisor-phone-input"]}`}
                >
                  <select>
                    <option>+91</option>
                    <option>+1</option>
                    <option>+44</option>
                  </select>
                  <input type="text" id="phone" />
                  <span
                    className={`${styles["withAdvisor-icon"]} ${styles["withAdvisor-check-icon"]}`}
                  >
                    ✔
                  </span>
                </div>
                <p className={styles["withAdvisor-helper-text"]}>
                  Verify with WhatsApp
                </p>
              </div>
            </div>
          </div>

          <div className={styles["User-Companydetails-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Your Requirements</h3>
              <p>
                Information entered here will be publicly displayed to match you
                with the right set of businesses. Fields specifically marked as
                'Private' will not be publicly displayed.
              </p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="interestedInOptions"
                >
                  You are interested in:
                </label>
                <div
                  className={`${styles["form-input"]} ${styles["checkbox-list"]}`}
                  id="interestedInOptions"
                >
                  <label>
                    <input
                      type="checkbox"
                      value="Acquiring / Buying a Business"
                      onChange={handleInterestedInChange}
                    />{" "}
                    Acquiring / Buying a Business
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Investing in a Business"
                      onChange={handleInterestedInChange}
                    />{" "}
                    Investing in a Business
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Lending to a Business"
                      onChange={handleInterestedInChange}
                    />{" "}
                    Lending to a Business
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Buying Property / Plant / Machinery"
                      onChange={handleInterestedInChange}
                    />{" "}
                    Buying Property / Plant / Machinery
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Taking up a Franchise / Distributorship / Sales Agency"
                      onChange={handleInterestedInChange}
                    />{" "}
                    Taking up a Franchise / Distributorship / Sales Agency
                  </label>
                </div>
              </div>
              {/* Industries Interested In */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  Select industries you are interested in:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="industriesInterested"
                  value={industriesInterested}
                  onChange={(e) => setIndustriesInterested(e.target.value)}
                  placeholder="Select multiple industries"
                />
              </div>

              {/* Locations Interested In */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="locationsInterested"
                >
                  Select locations you are interested in:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="locationsInterested"
                  value={locationsInterested}
                  onChange={(e) => setLocationsInterested(e.target.value)}
                  placeholder="Select multiple locations"
                />
              </div>

              {/* Deal Size Range */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="dealSizeRange">
                  Provide your deal size range:
                </label>
                <div className={styles["form-input"]}>
                  <input
                    className={styles["form-range"]}
                    type="number"
                    id="dealSizeMin"
                    value={dealSizeRange.min}
                    onChange={handleDealSizeChange}
                    placeholder="Min"
                  />
                  <span>to</span>
                  <input
                    className={styles["form-range"]}
                    type="number"
                    id="dealSizeMax"
                    value={dealSizeRange.max}
                    onChange={handleDealSizeChange}
                    placeholder="Max"
                  />
                </div>
              </div>

              {/* Current Location */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="currentLocation"
                >
                  Your current location:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="currentLocation"
                  value={currentLocation}
                  onChange={(e) => setCurrentLocation(e.target.value)}
                  placeholder="Enter your current location"
                />
              </div>

              {/* Company */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="companyName">
                  Your company:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="companyName"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="Enter your company name"
                />
              </div>

              {/* Designation */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="designation">
                  Your designation:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="designation"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  placeholder="Enter your designation"
                />
              </div>

              {/* Company Website or LinkedIn Profile */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="companyWebsite"
                >
                  Company website or LinkedIn profile:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="companyWebsite"
                  value={companyWebsite}
                  onChange={(e) => setCompanyWebsite(e.target.value)}
                  placeholder="Enter website or LinkedIn"
                />
              </div>

              {/* Business Factors */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="businessFactors"
                >
                  What factors are important to you when considering a business?
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="businessFactors"
                  value={businessFactors}
                  onChange={(e) => setBusinessFactors(e.target.value)}
                  placeholder="Enter important factors"
                ></textarea>
              </div>

              {/* About Your Company */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  Tell us about your company:
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>
              {/* Profile Picture */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="profilePicture"
                >
                  Upload your profile picture:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="profilePicture"
                  accept="image/*"
                  onChange={handleProfilePictureChange}
                />
              </div>
            </div>
          </div>

          <div className={styles["document-upload-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Documents & Proof</h3>
              <p>
                Documents help us verify and approve your profile faster.
                Document names entered here are publicly visible but are
                accessible only to introduced members.
              </p>
            </div>

            {/* Company Logo Upload */}
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="companyLogo">
                  Company Logo:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="companyLogo"
                  accept="image/*"
                  onChange={handleCompanyLogoChange}
                />
              </div>

              {/* Corporate Profile Upload */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="corporateProfile"
                >
                  Attach Corporate Profile and Terms of Engagement if any:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="corporateProfile"
                  accept="image/*"
                  onChange={handleCorporateProfileChange}
                />
              </div>

              {/* Proof of Business Upload */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="proofOfBusiness"
                >
                  Attach proof of business for faster verification:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="proofOfBusiness"
                  accept="image/*"
                  onChange={handleProofOfBusinessChange}
                />
              </div>
            </div>
          </div>

          <div className={styles["plan-selection"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Select a Plan</h3>
              <p>For more introductions, select a plan:</p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["plan-container"]}>
                {/* Plan Cards */}
                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("active")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Active Plan</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 7,999</p>
                  </div>
                </div>

                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("premium")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Premium Plan</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 9,999</p>
                  </div>
                </div>

                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("yearly")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Yearly Plan [ Recommended ]</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 24,999</p>
                  </div>
                </div>

                {/* Plan Features */}
                {selectedPlan && (
                  <div className={styles["plan-features"]}>
                    <h4>Plan Features:</h4>
                    <ul>
                      <li>
                        Connect with businesses which send you a proposal for
                        free
                      </li>
                      <li>
                        Access to metrics of all businesses to evaluate the
                        opportunity
                      </li>
                      <li>
                        Connect and instantly access Business Name, if business
                        has allowed
                      </li>
                      <li>
                        Connect and instantly access Contact Details, if
                        business has allowed
                      </li>
                      <li>Quick email support for your queries</li>
                      <li>Valid for a period of 1 year</li>
                    </ul>
                  </div>
                )}

                {/* Individual Services Toggle */}
                <div className={styles["individual-services"]}>
                  <div
                    onClick={toggleServices}
                    className={styles["toggle-services"]}
                  >
                    <h3>Select Individual Services</h3>
                    <span>{showServices ? "-" : "+"}</span>{" "}
                    {/* Toggle between + and - */}
                  </div>

                  {showServices && (
                    <div className={styles["services-list"]}>
                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>Hire an Account Manager</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 29,999</p>
                        </div>
                      </div>

                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>FastTrack Bundle</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 24,999</p>
                        </div>
                      </div>

                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>Unlimited Bundle</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 54,999</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className={styles["submit-button-container"]}>
                  {/* Terms and Conditions */}
                  <div className={styles["terms-container"]}>
                    <label>
                      <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={handleTermsChange}
                      />
                      I accept the Terms of Engagement
                    </label>
                  </div>
                  {/* Submit Button */}
                  <button
                    className={styles["submit-button"]}
                    disabled={!selectedPlan || !termsAccepted}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className={styles["upload-teasers"]}>
            <h2>Upload Teasers</h2>
            <p>
              Upload "No name" Teasers of your mandates here to find interested
              buyers/investors.
            </p>
            <div className={styles["upload-container"]}>
              <input
                type="file"
                accept="video/mp4"
                onChange={handleFileChange}
                className={styles["file-input"]}
              />
              <button
                onClick={handleUpload}
                className={styles["upload-button"]}
                disabled={!videoFile}
              >
                Upload Video
              </button>
            </div>
            {errorMessage && (
              <p className={styles["error-message"]}>{errorMessage}</p>
            )}
          </div>
        </div>
        {/* FAQ Section */}
        <div className={styles["withAdvisor-faq-section"]}>
          <div>
            {/* Profile Status Section */}
            <div className={styles["withAdvisor-profile-status-section"]}>
              <h3>Your Profile Status</h3>
              <ul>
                <li className={styles["withAdvisor-completed"]}>
                  Provide Details
                </li>
                <li className={styles["withAdvisor-pending"]}>
                  Verification Call
                </li>
                <li className={styles["withAdvisor-pending"]}>Approval</li>
              </ul>
            </div>
          </div>
          <div>
            <h3>Frequently Asked Questions</h3>
            <ul>
              <li>Who can create a Member Profile?</li>
              <li>I don’t want to reveal my company name</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactCompany;
